/**
 * *************************************
 *  SHADAPPS CONFIDENTIAL
 *  __________________
 *
 *  Created by Vittorio Tauro
 *
 *  2022 (c) ShadApps Srl
 *  All Rights Reserved.
 *
 *  NOTICE:  All information contained herein is, and remains
 *  the property of ShadApps Srl and its suppliers,
 *  if any. The intellectual and technical concepts contained
 *  herein are proprietary to ShadApps Srl.
 *  and its suppliers and may be covered by Italian, European and Foreign Patents,
 *  patents in process, and are protected by trade secret or copyright law.
 *  Dissemination of this information or reproduction of this material
 *  is strictly forbidden unless prior written permission is obtained
 *  from ShadApps Srl.
 * *************************************
 * */

// ----------------------------------------------------------------------

function path(root, sublink) {
    return `${root}${sublink}`;
}

const API_VERSION = `${window.configs.api.host}/api/v1`;

const GET_CHILDREN_PATH = '/get-children';
// ----------------------------------------------------------------------

export const PATH_API = {
    login: path(API_VERSION, '/auth/login'),
    logout: path(API_VERSION, '/auth/logout'),
    logoutAdmin: path(API_VERSION, '/auth/logout-admin'),
    me: path(API_VERSION, '/auth/me-admin'), // Admin-specific endpoint
    users: path(API_VERSION, '/users'),
    storage: path(API_VERSION, '/storage'),
    airplanetypes: path(API_VERSION, '/airplanetypes'),
    companies: path(API_VERSION, '/companies'),
    airports: path(API_VERSION, '/airports'),
    attributes: path(API_VERSION, '/attributes'),
    bookings: path(API_VERSION, '/bookings'),
    trips: path(API_VERSION, '/trips'),
    // bookingsByFlight: path(API_VERSION, "/bookings/by-flight"),
    cities: path(API_VERSION, '/cities'),
    cms: path(API_VERSION, '/cms'),
    countries: path(API_VERSION, '/countries'),
    flights: path(API_VERSION, '/flights'),
    passengers: path(API_VERSION, '/passengers'),
    uploads: path(API_VERSION, '/uploads'),
    airways: path(API_VERSION, '/airways'),
    seats: path(API_VERSION, '/seats'),
    tokens: path(API_VERSION, '/tokens'),
    editSeats: path(API_VERSION, '/seats/edit-seats'),
    seatsByFlight: path(API_VERSION, `${GET_CHILDREN_PATH}/seats`),
    confirmDelete: 'confirm-delete',
    inviteCodes: path(API_VERSION, '/inviteCodes'),
    pricingPolicies: path(API_VERSION, '/pricingPolicies'),
};

export const PATH_API_NEW = {
    // login: path(API_VERSION, "/auth/login"),
    // me: path(API_VERSION, "/auth/me"),
    // users: path(API_VERSION, "/users"),
    // storage: path(API_VERSION, "/storage"),
    airplanetypes: {
        root: PATH_API.airplanetypes,
        disable: (airplaneTypeId) =>
            `${PATH_API.airplanetypes}/${airplaneTypeId}/disable`,
        enable: (airplaneTypeId) =>
            `${PATH_API.airplanetypes}/${airplaneTypeId}/enable`,
    },
    // companies: path(API_VERSION, "/companies"),
    // airports: path(API_VERSION, "/airports"),
    // attributes: path(API_VERSION, "/attributes"),
    // bookings: path(API_VERSION, "/bookings"),
    // trips: path(API_VERSION, "/trips"),
    // // bookingsByFlight: path(API_VERSION, "/bookings/by-flight"),
    // cities: path(API_VERSION, "/cities"),
    // cms: path(API_VERSION, "/cms"),
    // countries: path(API_VERSION, "/countries"),
    // flights: path(API_VERSION, "/flights"),
    // passengers: path(API_VERSION, "/passengers"),
    // uploads: path(API_VERSION, "/uploads"),
    airways: {
        root: PATH_API.airways,
        confirmDelete: (airwayId) =>
            `${PATH_API.airways}/${airwayId}/confirm-delete`,
    },
    flights: {
        root: PATH_API.flights,
        byId: (id) => `${PATH_API.flights}/${id}`,
        getLinkedFlights: `${PATH_API.flights}/get-linked-flights`,
    },
    // seats: path(API_VERSION, "/seats"),
    // tokens: path(API_VERSION, "/tokens"),
    // editSeats: path(API_VERSION, "/edit-seats"),
    // seatsByFlight: path(API_VERSION, `${GET_CHILDREN_PATH}/seats` )
};
